import {
  Component,
  input,
  output,
} from '@angular/core';
import { Modal } from 'flowbite';
import { AnimationOptions } from 'ngx-lottie';
import { IRouteAlteration } from 'src/app/models';
import { LiteralService, UtilsService } from 'src/app/services';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-duplicate-alteration',
  templateUrl: './modal-duplicate-alteration.component.html',
  styleUrl: './modal-duplicate-alteration.component.scss',
  standalone: false,
})
export class ModalDuplicateAlterationComponent {
  id = input<string>();
  modal = input<Modal>();
  duplicating = input<boolean>();
  action = output<string>();

  public alterationName = '';
  public images = images;

  public optionsLoading: AnimationOptions = {
    path: '/assets/animations/loading.json',
  };

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
  ) {}

  change(alterationName: string) {
    this.alterationName = alterationName;
  }

  close() {
    this.modal()?.hide();
    this.alterationName = '';
  }

  onSubmit() {
    this.action.emit(this.alterationName);
    this.alterationName = '';
  }
}
